export default __webpack_public_path__ + "static/media/TheHoleMap.c1b5607e.jpg";